import { requestBuilder } from '../../http/RequestBuilder';

interface PlaidOAuthBody {
    auth_request_id: string;
}

interface PlaidOAuthResponse {
    redirectUri: string;
}

const usePlaidOAuth = requestBuilder.mutation<
    PlaidOAuthResponse,
    PlaidOAuthBody
>({
    endpoint: '/api/oauth/plaid',
    method: 'POST',
});

export default usePlaidOAuth;
